// extracted by mini-css-extract-plugin
export default {"wrapper":"cl6Y_tjRO5wMqrC8CJAt"};